export const enum FlagKeys {
  DATA_VIS = 'ca-my-bayer-data-visualization',
}
